export interface Testimonial {
  id: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    id: 'strip-1',
    role: 'Art Teacher',
    text: 'I used to spend every Sunday night searching for activities and trying to put together the next week’s art classes. Having everything organized by topic, technique and level completely changes the way I prepare.',
  },
  {
    id: 'strip-2',
    role: 'Visual Arts Teacher',
    text: 'The visual references are what I would use the most. Instead of spending time searching for examples online, I can open the material, show the technique, and move directly into the activity.',
  },
  {
    id: 'strip-3',
    role: 'Art Instructor',
    text: 'I teach students at different levels, so having beginner, intermediate and advanced possibilities inside the same system makes planning much easier.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    id: 'ext-1',
    role: 'Art Teacher',
    text: "The biggest difference is that I don't need to invent every art class anymore. I can start with a complete lesson and spend my preparation time adapting it to my students instead of building everything from zero.",
  },
  {
    id: 'ext-2',
    role: 'Visual Arts Teacher',
    text: 'The project variety is exactly what I would want in an art library. Painting, collage, printmaking, sculpture, mixed media—there is always another direction I can take the class.',
  },
  {
    id: 'ext-3',
    role: 'Art Instructor',
    text: 'The Visual Art Classroom Atlas makes explanations much easier. Being able to show students clear examples before they begin saves time and creates better understanding.',
  },
  {
    id: 'ext-4',
    role: 'Art Educator',
    text: 'I teach mixed-level groups, and the adaptations make it much easier to keep beginners and stronger students working on the same concept without giving everyone identical work.',
  },
  {
    id: 'ext-5',
    role: 'Visual Arts Educator',
    text: 'The emergency lessons are the kind of resource teachers only appreciate when they suddenly need one. If the schedule changes or a class finishes early, there is already something meaningful ready to use.',
  },
  {
    id: 'ext-6',
    role: 'Art Teacher',
    text: 'The assessment tools give me a much clearer way to discuss process, experimentation, revision and material choices instead of simply deciding whether I personally like the final artwork.',
  },
]

export const TESTIMONIAL_LABEL = 'Testimonial-style copy'
